import { render, staticRenderFns } from "./WorkspaceFooter.vue?vue&type=template&id=3b13df66&scoped=true&"
import script from "./WorkspaceFooter.vue?vue&type=script&lang=js&"
export * from "./WorkspaceFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b13df66",
  null
  
)

export default component.exports